import { AES, enc, mode, pad } from 'crypto-js';

export default class CryptoService {
  static encryptString(str: string) {
    const key = enc.Utf8.parse('greenstone706173');
    const iv = enc.Utf8.parse('greenstone706173');

    return AES.encrypt(
      str, key,
      {
        keySize: 128 / 8,
        iv,
        mode: mode.CBC,
        padding: pad.Pkcs7,
      },
    ).toString();
  }
  static decryptString(str: string) {
    const key = enc.Utf8.parse('greenstone706173');
    const iv = enc.Utf8.parse('greenstone706173');

    return AES.decrypt(
      str, key,
      {
        keySize: 128 / 8,
        iv,
        mode: mode.CBC,
        padding: pad.Pkcs7,
      },
    ).toString(enc.Utf8);
  }
}
